import MyPathPreview from "./MyPathPreview";

export default MyPathPreview;
